import _ from 'lodash';
import {SisDate} from 'util/SisDateTime';
import {changedKeys} from 'util/ObjectUtil';

/**
 * todo when all apps are using react -> transform to action/reducer
 */


export interface SharedAppState {
	view_start?: SisDate // visible view start
	view_end?: SisDate // visible view end
	view_start_fitted?: SisDate // used, when view shows a larger timespan than used (i.e. bookingCalendar month view)
	view_end_fitted?: SisDate // used, when view shows a larger timespan than used (i.e. bookingCalendar month view)
	view_kost_list?: string[] // active kostkeys (onClient)
}

let sharedAppState: SharedAppState = {}

let changeCallbacks: { id: number, fn: Function, filterAttrs?: string[] }[] = []
let cbID: number = 0;

export function addSharedAppStateChangeCallback(fn: Function, filterAttrs?: string[]) {
	const id = cbID++
	changeCallbacks.push({id, fn, filterAttrs}) // returns added index
	return id;
}

export function removeSharedAppStateChangeCallback(id: number) {
	changeCallbacks = changeCallbacks.filter(x => x.id !== id)
}

export function getSharedAppState() {
	return {...sharedAppState}
}

export function setSharedAppState(s: SharedAppState) {
	const oldState = sharedAppState
	sharedAppState = {
		...sharedAppState,
		...s,
	}
	const hasChanged = !_.isEqual(oldState, sharedAppState)
	if (hasChanged) {
		let changedAttrs = changedKeys(oldState, sharedAppState)
		changeCallbacks.forEach(x => {
			if (!x.filterAttrs || x.filterAttrs.some(a => changedAttrs.includes(a))) x.fn(getSharedAppState())
		})
	}
}